import classNames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { KetoProductCardImpression } from '@nerdwallet/react-marketplace-product-card';
import { DISPLAY_PAGES } from '@nerdwallet/react-marketplace-apply-now';
import { getProductType } from '@nerdwallet/marketplace/selectors/common';
import {
  CONTENT_TABS,
  DRIVER_GROUPS,
} from '@nerdwallet/react-marketplace-product-card/dist/marketplace-product-card';
import appConfig from '@nerdwallet/app-config';
import { PRODUCT_TABLE_TYPES } from '../../lib/constants';
import styles from './keto-product-card.module.less';
import SegmentImpression from '../segment-impression';

const KetoStructuredContent = ({
  identifier,
  identity,
  segmentImpressionId,
  pageViewId,
  analytics,
  updatedMarketplaceEntity,
  marketplaceEntity,
  omitRating,
  omittedTabs,
  compareButtonProps,
  headingProps,
  badgeProps,
  linkProps,
  driver,
  includeWhyThisProduct,
  includeWhyNerdsLoveIt,
  renderWhyThisProduct,
  renderWhyNerdsLoveIt,
  keyFacts,
  driverOverrides,
  location,
  heading,
  ctaText,
}) => {
  const driverOverridesMap = keyFacts?.map((item) => ({
    __typename: 'EntityPlacementDriver',
    description: null,
    label: item?.label,
    labelTooltip: null,
    tooltip: null,
    value: item?.text,
    valueTooltip: item?.tooltip,
    valueTooltipHasHtml: false,
  }));

  const driverOverridesConfig = driverOverrides
    ? {
        wrapDrivers: true,
        drivers: driverOverridesMap,
      }
    : {};

  const segmentImpressionProps = {
    impression_id: segmentImpressionId,
    pageview_id: pageViewId,
    // eslint-disable-next-line no-underscore-dangle
    deployable_name: appConfig?._meta?.deployable,
    // eslint-disable-next-line no-underscore-dangle
    deployable_version: appConfig?._meta?.version,
    sku_id: marketplaceEntity?.id,
    sku_level: marketplaceEntity?.entity_type,
    sku_name: marketplaceEntity?.name,
    sku_product_type: marketplaceEntity?.product_type,
    sku_source: 'marketplace',
    impression_page_url: location?.pathname,
    impression_pageview_id: segmentImpressionId,
    // impression_position: '', // TODO: to be implemented
    // impression_section: '', // TODO: to be implemented
    monetizable: marketplaceEntity?.derived_details?.monetizable?.value,
    sku_impression_id: segmentImpressionId,
  };
  const headingAndCtaTextOverrides = {
    ...(heading && { heading }),
    ...(ctaText && { ctaText }),
  };

  return (
    <div id={identifier} className={classNames(styles.ketoProductCard)}>
      <SegmentImpression
        eventName="KetoProductCard Viewed"
        eventProps={segmentImpressionProps}
      >
        <KetoProductCardImpression
          className={classNames([
            { [styles.fixUnstructuredKeyFacts]: driverOverrides },
          ])}
          {...headingAndCtaTextOverrides}
          analytics={analytics}
          displayPage={DISPLAY_PAGES.DIGITAL_MARKETING}
          identity={identity}
          marketplaceEntity={updatedMarketplaceEntity}
          omitRating={omitRating}
          omittedTabs={_.compact([
            ...omittedTabs,
            // Omit `key facts` tab for Personal Loans.
            getProductType(marketplaceEntity) ===
            PRODUCT_TABLE_TYPES.PERSONAL_LOANS
              ? CONTENT_TABS.KEY_FACTS
              : undefined,
          ])}
          driverGroup={driver || DRIVER_GROUPS.DEFAULT_DRIVER_GROUP}
          {...compareButtonProps}
          {...headingProps}
          {...badgeProps}
          {...linkProps}
          {...driverOverridesConfig}
        />
        {includeWhyThisProduct ? renderWhyThisProduct() : null}
        {includeWhyNerdsLoveIt ? renderWhyNerdsLoveIt() : null}
      </SegmentImpression>
    </div>
  );
};

KetoStructuredContent.propTypes = {
  identity: PropTypes.object,
  identifier: PropTypes.string,
  segmentImpressionId: PropTypes.string,
  pageViewId: PropTypes.string,
  analytics: PropTypes.object,
  updatedMarketplaceEntity: PropTypes.object,
  marketplaceEntity: PropTypes.object,
  omitRating: PropTypes.bool,
  omittedTabs: PropTypes.bool,
  driverOverrides: PropTypes.bool,
  compareButtonProps: PropTypes.object,
  headingProps: PropTypes.object,
  badgeProps: PropTypes.object,
  linkProps: PropTypes.object,
  driver: PropTypes.oneOf([...Object.values(DRIVER_GROUPS)]),
  includeWhyThisProduct: PropTypes.bool,
  includeWhyNerdsLoveIt: PropTypes.bool,
  renderWhyThisProduct: PropTypes.func,
  renderWhyNerdsLoveIt: PropTypes.func,
  keyFacts: PropTypes.arrayOf(PropTypes.string),
  location: PropTypes.string,
  heading: PropTypes.string,
  ctaText: PropTypes.string,
};

export default KetoStructuredContent;
